import { render } from "./HFO_MB_004_SNS.vue?vue&type=template&id=a68ab04a&scoped=true"
import script from "./HFO_MB_004_SNS.vue?vue&type=script&lang=js"
export * from "./HFO_MB_004_SNS.vue?vue&type=script&lang=js"

import "./HFO_MB_004_SNS.vue?vue&type=style&index=0&id=a68ab04a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68ab04a"]])

export default __exports__